import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteSurvey($surveyId: ID!) {
    adminDeleteSurvey(surveyId: $surveyId)
  }
`;
